/**
 * 购买页面使用，后期将租户与运营统一
 */
import { _bridge, appUtils, util, devmode, reactsupport, pageManager } from './bridge';
import { init as initTceLog } from './loader/lib/tceLog';
window.nmc = window.nmc || {};
/**
 * 渲染需要
 */
window.nmc.render = function (htmlStr, modName) {
  var appArea = window.$('#appArea');
  appArea.html(htmlStr);
};


window.TCE_LIB = {
  load: function (pageConfig) {
    //开发模式下
    if (devmode.isInDevMode()) {
      pageConfig.js = '//wds.tea.local/' + pageConfig.pathName + '.js#rx-app-tea2';
    }
    //加载文件路径
    reactsupport.loadFn(pageConfig['js'],
      function (_module) {
        //开始渲染
        var para = [pageConfig.pathName];
        pageManager.loadCommon(para);
      },
      null
    );
  }
};
_bridge('tce', window.TCE_LIB);
// 初始化tce 收集日志服务
initTceLog();

// 异步获取地域列表
(async function (){
  try {
    await window.tcesdk.region.getRegionListAsync()
  } catch (error) {
    console.log(error)
  }
})();